import { z } from "zod";
export const uuidSchema = z.string().uuid();
export const paginationSchema = z.object({
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
export const geoPointSchema = z.object({
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
    accuratezza_m: z.number().nonnegative().optional(),
});
// Vocabolari controllati — non modificare i valori stringa: sono contrattuali col mobile
export const ruoloSchema = z.enum([
    "OPERATORE",
    "BACKOFFICE_COMUNE",
    "BACKOFFICE_GESTORE",
    "ADMIN",
    "VISUALIZZATORE",
]);
export const frazioneMerceologicaSchema = z.enum([
    "ORGANICO",
    "CARTA",
    "PLASTICA_METALLO",
    "VETRO",
    "SECCO_RESIDUO",
    "VERDE",
    "ALTRO",
]);
export const qualitaConferimentoSchema = z.enum([
    "OK",
    "PARZIALE",
    "NON_CONFORME",
]);
export const causaleAnomaliaSchema = z.enum([
    "BIDONE_NON_ESPOSTO",
    "CONTENUTO_NON_CONFORME",
    "SOVRARIEMPIMENTO",
    "CONTENITORE_DANNEGGIATO",
    "ACCESSO_IMPEDITO",
    "ETICHETTA_ILLEGGIBILE",
    "BARCODE_NON_RICONOSCIUTO",
    "ALTRO",
]);
export const problemDetailsSchema = z.object({
    type: z.string(),
    title: z.string(),
    status: z.number().int(),
    detail: z.string().optional(),
    code: z.string().optional(),
});
//# sourceMappingURL=common.js.map